import EtablissementUserDisabled from '@/generated/controls/etablissement/EtablissementUserDisabled.vue';
import { defineComponent } from 'vue';

export default defineComponent({
  components: {},
  extends: EtablissementUserDisabled
})
